import { toPng } from 'html-to-image';
import { saveAs } from 'file-saver';

class ScreenshotService {
  /**
   * التقاط سكرين شوت لعنصر HTML
   * @param {HTMLElement} element - العنصر المراد التقاطه
   * @param {string} fileName - اسم الملف
   * @returns {Promise<Blob>} - الصورة كـ Blob
   */
  async captureElement(element, fileName = 'screenshot.png') {
    try {
      if (!element) {
        throw new Error('العنصر غير موجود');
      }

      // التقاط الصورة بجودة عالية
      const dataUrl = await toPng(element, {
        quality: 1.0,
        pixelRatio: 2, // جودة عالية للموبايل
        cacheBust: true,
        backgroundColor: '#ffffff'
      });

      // تحويل DataURL إلى Blob
      const response = await fetch(dataUrl);
      const blob = await response.blob();

      return { blob, dataUrl, fileName };
    } catch (error) {
      console.error('خطأ في التقاط الصورة:', error);
      throw error;
    }
  }

  /**
   * تحميل الصورة على الجهاز
   * @param {Blob} blob - الصورة
   * @param {string} fileName - اسم الملف
   */
  downloadImage(blob, fileName) {
    try {
      saveAs(blob, fileName);
      return true;
    } catch (error) {
      console.error('خطأ في تحميل الصورة:', error);
      return false;
    }
  }

  /**
   * فتح واتساب ويب مع نص مصاحب
   * @param {string} station - اسم المحطة
   * @param {string} date - التاريخ
   * @param {string} type - نوع التقرير (حضور/مهام)
   * @param {string} shift - الشيفت (نهار/ليل)
   */
  openWhatsApp(station, date, type, shift) {
    try {
      // تنسيق النص المصاحب
      const text = `تقرير ${type} شيفت ${shift}\n${station}\n${date}`;
      const encodedText = encodeURIComponent(text);
      
      // فتح واتساب ويب
      const whatsappUrl = `https://web.whatsapp.com/send?text=${encodedText}`;
      window.open(whatsappUrl, '_blank');
      
      return true;
    } catch (error) {
      console.error('خطأ في فتح واتساب:', error);
      return false;
    }
  }

  /**
   * تنسيق اسم الملف
   * @param {string} station - اسم المحطة
   * @param {string} type - نوع التقرير
   * @param {string} shift - الشيفت
   * @param {string} date - التاريخ
   * @returns {string} - اسم الملف المنسق
   */
  formatFileName(station, type, shift, date) {
    // إزالة المسافات والرموز الخاصة
    const cleanStation = station
      .replace(/\s+/g, '_')
      .replace(/[+]/g, '')
      .replace(/\d+/g, '')
      .trim();
    
    // تنسيق التاريخ
    const cleanDate = date.replace(/\//g, '-');
    
    return `${cleanStation}_${type}_${shift}_${cleanDate}.png`;
  }

  /**
   * معالجة السكرين شوت الكاملة
   * @param {string} elementId - معرف العنصر
   * @param {Object} data - بيانات التقرير
   * @param {string} action - الإجراء (download/whatsapp/both)
   */
  async handleScreenshot(elementId, data, action = 'download') {
    try {
      const element = document.getElementById(elementId);
      if (!element) {
        throw new Error('العنصر غير موجود');
      }

      // تنسيق اسم الملف
      const fileName = this.formatFileName(
        data.station,
        data.type,
        data.shift,
        data.date
      );

      // التقاط الصورة
      const { blob } = await this.captureElement(element, fileName);

      // تنفيذ الإجراء المطلوب
      if (action === 'download' || action === 'both') {
        this.downloadImage(blob, fileName);
      }

      if (action === 'whatsapp' || action === 'both') {
        // انتظار قليل لضمان اكتمال التحميل
        setTimeout(() => {
          this.openWhatsApp(data.station, data.date, data.type, data.shift);
        }, 500);
      }

      return true;
    } catch (error) {
      console.error('خطأ في معالجة السكرين شوت:', error);
      throw error;
    }
  }
}

export default new ScreenshotService();